export default "__VITE_ASSET__d656GUQJ__"